export var PositionType;
(function (PositionType) {
    PositionType["TIME"] = "TIME";
    PositionType["EBOOK"] = "EBOOK";
    PositionType["COMPLETED"] = "COMPLETED";
})(PositionType || (PositionType = {}));
//# sourceMappingURL=PositionType.js.map